import React, { useState, useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'

import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { PageTitle } from 'Components/PageTitle'
import { SettingsTile } from 'Components/Settings/SettingsTile'
import { SettingsWrapper } from 'Components/Settings/SettingsWrapper'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import SettingsIcon from 'Assets/Images/icons/settings'
import { authorization } from 'Module/Auth/Auth'
import { PATHS } from 'Config/Routing/paths'
import { ModalCustom } from '../../Components/Modal/ModalCustom'
import { apiXero } from '../../Module/API/Xero'
import { CONFIG } from '../../Config/config'
import StyledBreadcrumbs from '../../Components/StyledBreadcrumbs'

const linkToSuperset = 'https://superset.oppizi.com/'

const SettingsBreadcrumbs = () => (
  <StyledBreadcrumbs
    icon={<SettingsIcon style={{ width: 20 }} />}
    breadcrumbs={[
      {
        label: 'Settings',
      },
    ]}
  />
)

const Settings = () => {
  const [isModalShow, setModalShow] = useState(false)
  const allowedOrigins = [CONFIG.NEXT_BASE_URL]

  const user = authorization.getUser()
  const isSpain = user.countryCode === 'ES'
  const shouldHideSensitiveData = authorization.isCityManagerAssistant()
  const canUseSuperset =
    authorization.isCityManager() && !shouldHideSensitiveData

  useEffect(() => {
    const handleMessageOld = event => {
      if (allowedOrigins.includes(event.origin) && event.data === 'message') {
        const token = JSON.stringify(localStorage.apiKey)
        event.source.postMessage(token, event.origin)
      }
    }
    window.addEventListener('message', handleMessageOld)

    return () => {
      window.removeEventListener('message', handleMessageOld)
    }
  }, [])

  return (
    <HideWhenBlocked>
      <SettingsWrapper>
        <LayoutDashboard>
          <SettingsBreadcrumbs />
          <PageTitle>Settings</PageTitle>
          <div>
            {authorization.isAdmin() && (
              <Row>
                <Col xs={12}>
                  <SettingsTile
                    label="Signup Identification Documents"
                    linkLabel="View/Edit"
                    path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
                      PATHS.settings.documentation
                    }`}
                  />
                  <SettingsTile
                    label="Invoice Export"
                    linkLabel="View/Edit"
                    path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
                      PATHS.settings.invoiceExport
                    }`}
                  />
                  <SettingsTile
                    label="Tags management"
                    linkLabel="View/Edit"
                    path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
                      PATHS.settings.tagsManagement
                    }`}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12}>
                {authorization.isAdmin() && (
                  <React.Fragment>
                    <SettingsTile
                      label="Legal Documents"
                      linkLabel="View/Edit"
                      path={`${PATHS.main.dashboard}${
                        PATHS.dashboard.settings
                      }${PATHS.settings.legalDocumentation}`}
                    />
                    <SettingsTile
                      label="NPS score"
                      linkLabel="View"
                      path={`${PATHS.main.dashboard}${
                        PATHS.dashboard.settings
                      }${PATHS.settings.npsScore}`}
                    />
                  </React.Fragment>
                )}
                {canUseSuperset && (
                  <React.Fragment>
                    <SettingsTile
                      label="Superset"
                      linkLabel="View"
                      onClick={() => setModalShow(true)}
                    />
                    <ModalCustom
                      handleCancel={() => setModalShow(false)}
                      handleConfirm={() => {
                        window.open(linkToSuperset, '_blank')
                      }}
                      modalShow={isModalShow}
                      title="Use this 'Username' and 'Password'"
                      text=" "
                      children={
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                          }}
                        >
                          <div>Username: oppizi</div>
                          <div>Password: oppizi</div>
                        </div>
                      }
                      cancelText="Cancel"
                      confirmText="Go to Superset"
                    />
                  </React.Fragment>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <SettingsTile
                  label="URL Shortener"
                  linkLabel="View"
                  path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
                    PATHS.settings.urlShortener
                  }`}
                />
                {apiXero.isHaveXeroAccess() && (
                  <SettingsTile
                    label="Xero Connection"
                    linkLabel="View/Edit"
                    path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
                      PATHS.settings.xeroConnection
                    }`}
                  />
                )}
                {apiXero.isHaveXeroAccess() && isSpain ? (
                  <SettingsTile
                    label="Withhold payments in Xero"
                    linkLabel="View"
                    path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
                      PATHS.settings.addPayment
                    }`}
                  />
                ) : null}
                {authorization.isAdmin() && (
                  <SettingsTile
                    label="Promofy Meeting"
                    linkLabel="Open"
                    href="https://meeting.oppizi.com/admin"
                  />
                )}
              </Col>
            </Row>
          </div>
        </LayoutDashboard>
      </SettingsWrapper>
    </HideWhenBlocked>
  )
}

export default Settings
